import { FC, useState } from 'react';
import EditorImg from 'lowcode/components/EditorImg';
import css from './index.module.scss';
import { useLang } from '@/i18n';
import { useRouter } from 'next/router';

const TheComp: FC = () => {
    const { t } = useLang('dp3.landing.ExploreSecure');
    const { locale = 'us' } = useRouter();
    const item1TipsText = t.rich('item1_tips', {
        code1: (text: string) => {
            return <span>{text}</span>;
        },
    });
    const [list, setList] = useState([
        {
            pc:
                locale === 'cn'
                    ? 'https://websiteoss.ecoflow.com/upload/image/1737777663139/5_1.jpg'
                    : 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718872360516/a1.jpg',
            title: t('item1_title'),
            desc: t.rich('item1_desc', {
                code1: (text: string) => {
                    return (
                        <span className="comp-item-desc-tips">
                            {text}
                            <dialog className="comp-item-desc-dialog">{item1TipsText}</dialog>
                        </span>
                    );
                },
            }),
        },
        {
            pc:
                locale === 'cn'
                    ? 'https://websiteoss.ecoflow.com/upload/image/1737777662949/5_2.jpg'
                    : 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718872374254/a2.jpg',
            title: t('item2_title'),
            desc: t('item2_desc'),
        },
        {
            pc:
                locale === 'cn'
                    ? 'https://websiteoss.ecoflow.com/upload/image/1737777663314/5_3.jpg'
                    : 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718872389527/a3.jpg',
            title: t('item3_title'),
            desc: t('item3_desc'),
        },
        {
            pc:
                locale === 'cn'
                    ? 'https://websiteoss.ecoflow.com/upload/image/1737777662781/5_4.jpg'
                    : 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718708932873/c4.jpg',
            title: t('item4_title'),
            desc: t('item4_desc'),
        },
    ]);
    return (
        <div className={`${css.thecomp} GtmModuleData-section`} data-section-id={'dp3-ExploreSecure'} data-section-title={t('title')}>
            <div className="dp3-title">{t('title')}</div>
            <div className="comp-module">
                {list.map((item, index) => (
                    <div key={index} className={`comp-item  comp-item-${index + 1}`}>
                        <div className="comp-item-img">
                            <EditorImg pc={item.pc} />
                        </div>
                        <div className="comp-item-msg">
                            <div className="comp-item-title">{item.title}</div>
                            <div className="comp-item-desc">{item.desc}</div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default TheComp;
